import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../../services/toast.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isHandlingSessionExpired = false;

  constructor(
    private auth: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const user = this.auth.getUser();
    const token = user?.token;
    const isLoginRequest = req.url.includes('/api/usuarios/authenticate') || req.url.includes('api/usuarios/authenticate');

    if (!token) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (!isLoginRequest && (error.status === 401 || error.status === 403)) {
            this.handleSessionExpired();
          }

          return throwError(() => error);
        })
      );
    }

    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!isLoginRequest && (error.status === 401 || error.status === 403)) {
          this.handleSessionExpired();
        }

        return throwError(() => error);
      })
    );
  }

  private handleSessionExpired(): void {
    if (this.isHandlingSessionExpired) {
      return;
    }

    this.isHandlingSessionExpired = true;
    const retUrl = this.router.url || '/';

    this.auth.logout();
    this.toastService.show('Sua sessão expirou. Faça login novamente.', { type: 'warning' });

    this.router.navigate(['/login'], {
      queryParams: { retUrl }
    }).finally(() => {
      this.isHandlingSessionExpired = false;
    });
  }
}